<div class="searchable-select" #dropdown>
	<div class="select-label" *ngIf="label">{{ label }}</div>
	<div
		class="select-trigger"
		[class.disabled]="disabled"
		[class.open]="isOpen"
		(click)="toggleDropdown(); $event.stopPropagation()"
	>
		<input
			type="text"
			class="select-display"
			[value]="getDisplayValue()"
			readonly
			[disabled]="disabled"
			[placeholder]="placeholder"
		/>
		<mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
	</div>

	<div class="select-dropdown" *ngIf="isOpen" (click)="$event.stopPropagation()">
		<div class="dropdown-header" *ngIf="searchable">
			<input
				#searchInput
				type="text"
				class="search-input"
				[placeholder]="searchPlaceholder"
				[(ngModel)]="searchQuery"
				(ngModelChange)="filterOptions()"
				(click)="$event.stopPropagation()"
			/>
		</div>

		<div class="dropdown-actions" *ngIf="multiple">
			<label class="select-all-label">
				<input
					type="checkbox"
					class="select-all-checkbox"
					[checked]="isAllSelected()"
					[indeterminate]="!isAllSelected() && isAnySelected()"
					(change)="isAllSelected() ? clearSelection() : selectAll()"
				/>
				<span>Select all</span>
			</label>
			<button
				type="button"
				class="clear-button"
				(click)="clearSelection()"
				*ngIf="isAnySelected()"
			>
				Clear
			</button>
		</div>

		<div class="dropdown-options">
			<div class="loading-indicator" *ngIf="loading">
				<div class="spinner"></div>
				<span>Loading options...</span>
			</div>
			<ng-container *ngIf="!loading">
				<div
					*ngFor="let option of filteredOptions"
					class="dropdown-option"
					[class.selected]="isSelected(option) && !multiple"
					(mousedown)="onOptionMouseDown($event, option)"
					(click)="$event.stopPropagation()"
				>
					<input
						*ngIf="multiple"
						type="checkbox"
						class="option-checkbox"
						[checked]="isSelected(option)"
						(change)="toggleSelection(option)"
						(mousedown)="$event.stopPropagation()"
					/>
					<mat-icon
						*ngIf="!multiple && isSelected(option)"
						class="option-checkmark">
						check
					</mat-icon>
					<span class="option-label">{{ option.label }}</span>
				</div>
				<div class="no-results" *ngIf="filteredOptions.length === 0">
					No results found
				</div>
			</ng-container>
		</div>
	</div>
</div>

